import { useEffect, useRef, useState } from 'react';

interface VideoPlayerProps {
  videoId: string;
}

export default function VideoPlayer({ videoId }: VideoPlayerProps) {
  const playerRef = useRef<HTMLDivElement>(null);
  const [isApiReady, setIsApiReady] = useState(false);

  useEffect(() => {
    // Add window type for YT
    if (!(window as any).YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';

      // Create a callback for when API is ready
      (window as any).onYouTubeIframeAPIReady = () => {
        setIsApiReady(true);
      };

      document.body.appendChild(tag);

      return () => {
        document.body.removeChild(tag);
        delete (window as any).onYouTubeIframeAPIReady;
      };
    } else {
      setIsApiReady(true);
    }
  }, []);

  useEffect(() => {
    if (!playerRef.current || !isApiReady || !videoId) return;

    const player = new (window as any).YT.Player(playerRef.current, {
      videoId,
      playerVars: {
        autoplay: 1,
        controls: 1,
        modestbranding: 1,
        rel: 0,
      }
    });

    return () => {
      player.destroy();
    };
  }, [videoId, isApiReady]);

  if (!videoId) {
    return <div>No video selected</div>;
  }

  return (
    <div ref={playerRef} className="w-full h-full" />
  );
}